import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Category10 from "../../components/category/Category10";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumb from "../../components/breadcrumb";
import Breadcrumbhoroscope from "../../components/breadcrumbhoroscope";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";


Horoscopes.propTypes = {};

function Horoscopes(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  

  const { clientId } = useParams();
  const [predictions, setPredictions] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    // 🔗 Call your backend API to get predictions for this clientId
    axios
      .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/gethoroscopesbyid/${clientId}`)
      .then((response) => {
        setPredictions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching predictions:", error);
      });
  }, [clientId]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const [category, setCategory] = useState({ Named: "" });

  useEffect(() => {
    const fetchCategoryDetails = async () => {
      try {
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/get-horoscope-details/${clientId}`);
        setCategory(response.data); // Assuming response contains Named, Path1, Fdesc
      } catch (error) {
        console.error("Error fetching category details:", error);
      }
    };

    fetchCategoryDetails();
  }, [clientId]);

  
  
  const [horoscopeOptions, setHoroscopeOptions] = useState([]);


  const fetchHoroscopeCategories = async () => {
    try {
      const response = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"
      );
      setHoroscopeOptions(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  useEffect(() => {
    fetchHoroscopeCategories();
  }, []);


    const navigate = useNavigate();
  const handleDropdownChange = (e) => {
    const selectedId = e.target.value;
    if (selectedId) {
      navigate(`/horoscopes/${selectedId}`);
    }
  };

  

  
  return (
    <>
   <Helmet>
     <title>{category?.Named ? `${category.Named} - Adhigyanam | Sauntesthyam LLP` : 'Loading... | Adhigyanam'}</title>
   </Helmet>
          <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

         <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
          </div>
          <div className="header-customize-item button">
            <Link to="/login">My Account</Link>
          </div>

          <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
        </div>
      </div>

      
      <Header2 clname="act1" handleMobile={handleMobile} />
        <Breadcrumbhoroscope title={category.Named} />
        <section className="testimonials-category-section" style={{paddingTop:"30px", paddingBottom:"30px"}}>
        <div className="tf-container">
          <div className="title-iconbox style-3 stc" style={{paddingBottom:"40px"}}>
        
    <h1 style={{ marginBottom: "3px", fontSize:"30px" }}>
    Horoscope: <span style={{color:"rgb(20, 160, 119)"}}>{category.Named}</span>
    </h1>
 
                <p style={{maxWidth:"900px", margin:"auto", padding:"auto"}}>
                “<b>Discover personalized horoscope predictions based on astrological insights</b>. Each prediction is thoughtfully crafted to offer guidance, clarity, and awareness.”</p>
          </div>
          <div className="row"  style={{textAlign:"center", maxWidth:"1200px", margin:"auto"}}>
           
            <div className="col-lg-9">
            <div className="box-content" style={{ textAlign: "left" }}>

            
       <p style={{marginBottom:"15px"}}><b style={{fontSize:"17px", lineHeight:"24px"}}>Know Your Horoscope</b><br/>{category.Fdesc}</p>        

{predictions.length > 0 ? (
    predictions.map((item, index) => (
          <div
            key={index}
            className="border border-gray-300 rounded-md mb-3"
            style={{ backgroundColor: "#fafafa" }}
          >
            <div
              className="flex justify-between items-center px-4 py-3 cursor-pointer bg-gray-100 hover:bg-gray-200 w-full"
              style={{ paddingBottom: "0.5rem", border:"solid #f2f2f2 2px" }}
              onClick={() => toggleAccordion(index)}
            >
              <span
                className="text-lg font-medium text-gray-800 break-words pr-4"
                style={{ fontWeight: "bold" }}
              >
                {item.Title}
              </span>
              <span
                className="text-xl text-gray-600 whitespace-nowrap"
                style={{ float: "right", cursor: "pointer" }}
              >
                {openIndex === index ? "▲" : "▼"}
              </span>
            </div>

            {openIndex === index && (
              <div className="bg-white px-4 py-1 text-gray-700">
                <ul className="list-disc pl-5">
                  <li className="mb-1">{item.Descriptions}</li>
                </ul>
              </div>
            )}
          </div>
        ))
      ) : (
        <p
  className="text-center text-gray-600 bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-5 shadow-sm"
  style={{ fontSize: "16px", fontWeight: "500", width: "100%", margin: "20px auto" }}
>
  🔮 No predictions found for the selected horoscope. 🔮<br/>Please try selecting another category or date.
</p>
      )}
    </div>
            <div>
                  
                
                 
              
                    
                   
                 
                </div>
           
            </div>
             <div className="col-lg-3">
            <div>
                  
                  <div className="box-content"  style={{textAlign:"left"}}>
                
                  <div className="group-input">
        
      <div className="ip" style={{marginTop:"12px", marginBottom:"30px"}}>
       <select
        id="horoscope-select"
        value={clientId || ""}
        onChange={handleDropdownChange}
        style={{ background: "#f5f5f5", color:"black", paddingRight:"20px", border:"solid rgb(20, 160, 119) 2px", borderRadius:"3px", fontWeight:"bold" }}
      >
        <option value="">-- Select Your Horoscope --</option>
        {horoscopeOptions.map((option) => (
          <option key={option.Id} value={option.Id}>
            Selected Horoscope: {option.Named}
          </option>
        ))}
      </select>
      </div> </div>
       <img src={require ('../../assets/siteimages/horoscope.webp')} style={{width:"100%", height:"auto", margin:"auto", padding:"0px", marginBottom:"12px"}} alt="images" />

                   
                  </div>
                </div>
            <div>
       
      </div>
            </div>
          </div>
        </div>
      </section>
        
      
     <div
               className="floating-buttons"
               style={{
                 position: "fixed",
                 bottom: "20px",
                 left: "20px",
                 zIndex: "1000",
                 display: "flex",
                 flexDirection: "column",
                 gap: "10px",
               }}
             >
               {/* Call Button */}
               <a
                 href={`tel:+918960708425`}
                 style={{
                   display: "flex",
                   alignItems: "center",
                   justifyContent: "center",
                   width: "60px",
                   height: "60px",
                   backgroundColor: "#007BFF",
                   borderRadius: "50%",
                   boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                   color: "white",
                   fontSize: "28px",
                 }}
               >
                 <FaPhoneAlt />
               </a>
             
               {/* WhatsApp Button */}
               <a
                 href={`https://wa.me/918960708425`}
                 target="_blank"
                 rel="noopener noreferrer"
                 style={{
                   display: "flex",
                   alignItems: "center",
                   justifyContent: "center",
                   width: "60px",
                   height: "60px",
                   backgroundColor: "#25D366",
                   borderRadius: "50%",
                   boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                   color: "white",
                   fontSize: "28px",
                 }}
               >
                 <FaWhatsapp />
               </a>
             </div>
      <Footer />
      <Gotop />
    </>
  );
}

export default Horoscopes;
